import React, { Component, Fragment } from 'react';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import PropTypes from 'proptypes';
import { readableResponseMessage, grabPrimaryName, scroller } from 'ux-helpers';
import { Auth, API, Storage } from 'aws-amplify';
import Modal from 'react-modal';
import VisaPreviewModal from './previewModals/VisaPreviewModal';

export default class Visa extends Component {
  state = {
    visaDoc: this.props.visa ? this.props.visa : {},
  };

  // componentDidMount() {
  //   let uploadField;

  //   if (document.getElementById("initial-visa-upload-field") !== null) {
  //     uploadField = document.getElementById("initial-visa-upload-field");
  //   } else {
  //     uploadField = document.getElementById("update-visa-upload-field");
  //   }

  //   if (
  //     Object.keys(this.state.visaDoc).length &&
  //     this.state.visaDoc.status !== "No Visa Needed Based on Citizenship"
  //   ) {
  //     uploadField.onchange = () => {
  //       if (uploadField.files[0].size > 2000000) {
  //         this.setState({
  //           successOrErrorMessage: false,
  //           message: "File size exceeds 2mb. Please choose a smaller file."
  //         });
  //         uploadField.value = "";
  //       } else {
  //         this.setState({
  //           message: ""
  //         });
  //       }
  //     };
  //   }
  // }

  onImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 4000000) {
        this.setState({
          successOrErrorMessage: false,
          message: 'File size exceeds 4mb. Please choose a smaller file.',
        });
      } else {
        const reader = new FileReader();
        reader.addEventListener(
          'load',
          () =>
            this.setState({
              travelDocument: reader.result,
            }),
          false
        );
        reader.readAsDataURL(e.target.files[0]);
        this.visaForm.controls.travelDocument.setValue(e.target.files[0]);
        this.setState({
          travelDocumentFileName: e.target.files[0].name,
          message: '',
        });
      }
    }
  };

  uploadDocument = document => {
    const fileName = document.name;
    const fileType = document.type;
    Storage.put(fileName, document, {
      level: 'protected',
      contentType: fileType,
    }).catch(error => {
      this.setState({
        message: 'Whoops! Looks like we had a problem uploading your file.',
      });
    });
  };

  returnFileNameAndType = () => {
    const url = this.state.visaDoc.travelDocumentURL;
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return {
      key: url,
      type: extension,
    };
  };

  openModal = modalName => {
    let fileAttributes = this.returnFileNameAndType();
    Storage.get(fileAttributes.key, { level: 'protected' })
      .then(result => {
        if (
          fileAttributes.type === 'pdf' ||
          fileAttributes.type === 'doc' ||
          fileAttributes.type === 'docx'
        ) {
          window.open(result);
        } else {
          this.setState({
            previewUrl: result,
            activeModal: modalName,
          });
        }
      })
      .catch(() => {});
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.visaForm.status === 'VALID') {
      this.setState({ loadingBtn: true });
      this.visaForm.handleSubmit();
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: {
            userId: this.props.userId,
            userName: user.idToken.payload.nickname,
            travelDocument: this.state.travelDocument,
            fileName: this.state.travelDocumentFileName,
          },
        };
        this.uploadDocument(this.visaForm.controls.travelDocument.value);
        API.post('give-api', `/documents/${this.props.tripId}/visa/`, options)
          .then(response => {
            this.setState({
              successOrErrorMessage: true,
              loadingBtn: false,
              message: response.Message,
              visaDoc: {
                travelDocumentURL: response.Data.travelDocumentUrl
                  ? response.Data.travelDocumentUrl
                  : this.state.visaDoc.travelDocumentURL,
              },
            });
            this.props.setDocumentsAccordionState('visa');
            this.visaForm.handleSubmit();
            this.setState({ travelDocument: '' });
            this.props.deactiveActiveAccordion('visa-widget');
            scroller('visaScrollTo');
            setTimeout(() => {
              this.setState({ message: '' });
            }, 3000);
          })
          .catch(error => {
            this.setState({
              successOrErrorMessage: false,
              loadingBtn: false,
              message: readableResponseMessage(error),
            });
            this.visaForm.handleSubmit();
          });
      });
    } else {
      this.visaForm.handleSubmit();
    }
  };

  visaForm = FormBuilder.group({
    travelDocument: [
      this.state.visaDoc && this.state.visaDoc.travelDocumentURL
        ? this.state.visaDoc.travelDocumentURL
        : '',
      Validators.required,
    ],
  });

  render() {
    const { mailingCountry, destination } = this.props;

    return (
      <div id="visaScrollTo">
        {this.state.visaDoc.reasonDeclined ? (
          <div className="col-md-12 warning-text-container">
            <p className="warning-color">{this.state.visaDoc.reasonDeclined}</p>
          </div>
        ) : (
          ''
        )}
        {grabPrimaryName(destination) === 'Nicaragua' ||
        grabPrimaryName(destination) === 'Nicaragua PKG' ? (
          <Fragment>
            {mailingCountry === 'United States' ||
            mailingCountry === 'Canada' ||
            mailingCountry === 'Australia' ||
            mailingCountry === 'United Kingdom' ? (
              <p>
                As a citizen of{' '}
                {mailingCountry === 'United States' ? `the ${mailingCountry}` : mailingCountry} you
                are not required to obtain a visa to enter into Nicaragua. You must still pay a $10
                USD entry fee and have a valid passport, to stay up to 90 days.
              </p>
            ) : (
              <p>
                As a citizen of {mailingCountry}, (except European Union) you may be required to
                obtain a visa either upon entry or prior to arrival in country. Contact the
                Nicaraguan consulate closest to your native country in order to determine your visa
                requirements.{' '}
                <a href="https://www.visahq.com/" target="_blank" rel="noopener noreferrer">
                  Click here
                </a>{' '}
                for more information.{' '}
              </p>
            )}
          </Fragment>
        ) : (
          ''
        )}

        {destination === 'Tanzania' ? (
          <Fragment>
            <p>
              GIVE requires that you obtain your travel visa prior to your arrival in Tanzania to
              avoid complications and extended wait times at the customs desk in Dar es Salaam. This
              process is both simple and timely, as you can now apply for an online e-visa. <br />
              <br />
              <span className="round-icon small">1</span> Please review e-visa instructions{' '}
              <a
                href="https://cdn.givevolunteers.org/uploads/20200317204125/Tanzania-E-Visa-Instructions-2020.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .<br />
              <br />
              <span className="round-icon small">2</span> Upload your approved e-visa pdf document
              below.
            </p>
          </Fragment>
        ) : (
          ''
        )}

        {destination === 'Thailand' ? (
          <Fragment>
            {mailingCountry === 'United States' ||
            mailingCountry === 'Canada' ||
            mailingCountry === 'Ireland' ||
            mailingCountry === 'Australia' ||
            mailingCountry === 'New Zealand' ||
            mailingCountry === 'South Africa' ||
            mailingCountry === 'United Kingdom' ? (
              <p>
                As a citizen of{' '}
                {mailingCountry === 'United States' || mailingCountry === 'United Kingdom'
                  ? `the ${mailingCountry}`
                  : mailingCountry}
                , traveling to Thailand, you are exempt from obtaining a travel visa if you arrive
                by air and stay no more than 30 days, arrive by land and stay no more than 15 days,
                and have proof of departure from Thailand within the required timeframe.
              </p>
            ) : (
              <Fragment>
                <p>
                  To determine if you are required to obtain a visa either upon entry or prior to
                  arrival in Thailand, you can contact the Thai consulate closest to your native
                  country.{' '}
                  <a href="https://www.visahq.com/" target="_blank" rel="noopener noreferrer">
                    Click here
                  </a>{' '}
                  for a quick assessment.
                </p>
                <p>
                  If you need a visa to enter into Thailand, GIVE strongly recommends that you
                  obtain your travel visa prior to arrival to avoid complications and extended
                  waiting.
                </p>
              </Fragment>
            )}
          </Fragment>
        ) : (
          ''
        )}

        {destination === 'Laos' || destination === 'Southeast Asia: Thailand & Laos' ? (
          <Fragment>
            <p>
              Travelers are required to obtain a visa upon arrival to Laos at the Luang Prabang
              Airport.{' '}
              <a
                href="https://www.givevolunteers.org/wp-content/uploads/laos_visa_information_1.10.17.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Please review full instructions and information here
              </a>{' '}
              for complete instructions.
            </p>
          </Fragment>
        ) : (
          ''
        )}

        {destination === 'Nepal' || destination === 'Nepal Tibetan Frontier' ? (
          <p>
            Travelers to Nepal are required to obtain a visa and will be obtaining it upon arrival
            into Kathmandu at the Tribhuvan International Airport. Please review full instructions
            on obtaining your Nepal Tourist Visa by downloading the complete instructions{' '}
            <a
              href="https://www.givevolunteers.org/wp-content/uploads/Nepal-Tourist-Visa-Information-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              here.
            </a>
          </p>
        ) : (
          ''
        )}

        {destination === 'WILD: Pacific Northwest' ? (
          <p>
            To determine if you are required to obtain a visa either upon entry or prior to arrival
            in United States, you can contact the U.S. consulate closest to your native country.{' '}
            <a href="https://www.visahq.com/" target="_blank" rel="noopener noreferrer">
              Click here
            </a>{' '}
            for a quick assessment.
          </p>
        ) : (
          ''
        )}

        <div>
          {(mailingCountry === 'United States' ||
            mailingCountry === 'Canada' ||
            mailingCountry === 'Australia' ||
            mailingCountry === 'United Kingdom') &&
          (grabPrimaryName(destination) === 'Nicaragua' ||
            grabPrimaryName(destination) === 'Nicaragua PKG') ? (
            ''
          ) : (
            <Fragment>
              {this.state.message ? (
                <p
                  className={`center ${
                    this.state.successOrErrorMessage === true ? 'success' : 'error'
                  }`}
                >
                  {this.state.message}
                </p>
              ) : (
                ''
              )}
              <FieldGroup
                control={this.visaForm}
                render={({ value, submitted }) => (
                  <form
                    name="Visa"
                    id="visa-form"
                    onSubmit={e => this.handleSubmit(e, value)}
                    autoComplete="off"
                  >
                    {this.state.visaDoc && !this.state.visaDoc.travelDocumentURL ? (
                      <div>
                        <FieldControl
                          name="travelDocument"
                          render={({ touched, hasError }) => (
                            <div className="inputContainer">
                              <input
                                id="initial-visa-upload-field"
                                className="form-control"
                                type="file"
                                onChange={this.onImageSelect}
                              />
                              <label htmlFor="travelDocument" className="label notEmpty">
                                Visa Document
                                <span className="error">
                                  {(touched || submitted) && hasError('required') && ' - Required'}
                                </span>
                              </label>
                            </div>
                          )}
                        />
                      </div>
                    ) : null}
                  </form>
                )}
              />
              {this.state.visaDoc && this.state.visaDoc.travelDocumentURL ? (
                <div>
                  <p>
                    Visa Uploaded!{' '}
                    <button
                      className="inline btn-plain-text"
                      onClick={() => this.openModal('visaPreviewModal')}
                    >
                      &#8226; Preview
                    </button>
                    <span className="upload-btn-wrapper">
                      &#8226; {!this.state.travelDocument ? 'Update Visa Document' : 'Update'}
                      <input
                        id="update-visa-upload-field"
                        type="file"
                        onChange={this.onImageSelect}
                      />
                    </span>
                  </p>
                  <br />
                </div>
              ) : null}
              <button
                id="visaDocument"
                onClick={e => this.handleSubmit(e)}
                className={`${this.state.loadingBtn ? 'btn-text-hide' : ''}`}
                type="submit"
                disabled={this.state.loadingBtn}
              >
                Upload
                <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
              </button>
            </Fragment>
          )}
          <p className="muted">
            PLEASE NOTE THAT VISA INFORMATION IS SUBJECT TO CHANGE BY NATIONAL IMMIGRATION AND
            CUSTOMS AGENCIES. CHECK WITH YOUR NATIVE CONSULATE FOR VISA DETAILS WELL BEFORE YOUR
            DEPARTURE DATE.
          </p>
        </div>
        <Modal
          isOpen={this.state.activeModal === 'visaPreviewModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <VisaPreviewModal previewUrl={this.state.previewUrl} closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

Visa.propTypes = {
  userId: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  destination: PropTypes.string.isRequired,
  mailingCountry: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  setDocumentsAccordionState: PropTypes.func.isRequired,
  visa: PropTypes.shape({
    destination: PropTypes.string,
    duetDate: PropTypes.string,
    extensionDateTravelDoc: PropTypes.string,
    extensionNotes: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    travelDocumentURL: PropTypes.string,
  }).isRequired,
};
